import React from 'react'
import { history } from '../store'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { authLogin } from '../actions/auth'
import rateLimiter from '../utils/rateLimiter'
import LoginLangSelector from '../components/LoginLangSelector'

function genCaptcha() {
  const ops = ['+', '-', '×']
  const op = ops[Math.floor(Math.random() * ops.length)]
  let a, b, answer
  if (op === '+') { a = Math.ceil(Math.random() * 20); b = Math.ceil(Math.random() * 20); answer = a + b }
  else if (op === '-') { a = Math.ceil(Math.random() * 10) + 10; b = Math.ceil(Math.random() * 10); answer = a - b }
  else { a = Math.ceil(Math.random() * 9); b = Math.ceil(Math.random() * 9); answer = a * b }
  return { q: `${a} ${op} ${b} = ?`, answer }
}

const STYLES = `
.lv-wrap{display:flex;min-height:100vh;background:url(/images/login_bg.png) center/cover no-repeat;position:relative}
.lv-wrap::before{content:'';position:absolute;inset:0;pointer-events:none}
.lv-hero{flex:1;position:sticky;top:0;height:100vh;display:flex;align-items:center;justify-content:center;padding:40px;z-index:1}
.lv-hero img{max-width:480px;width:100%;opacity:.9}
.lv-panel{width:480px;min-height:100vh;background:rgba(0,18,40,.50);backdrop-filter:blur(14px);border-left:1px solid rgba(255,255,255,.12);display:flex;flex-direction:column;align-items:center;justify-content:center;padding:48px 40px;overflow-y:auto;position:relative;z-index:1}
.lv-logo{height:42px;margin-bottom:8px}
.lv-title{color:#fff;font-size:22px;font-weight:700;letter-spacing:4px;margin-bottom:24px}
.lv-admin-badge{padding:8px 20px;border-radius:40px;background:linear-gradient(45deg,#044D8B,#E0F05D);color:#fff;display:flex;align-items:center;gap:10px;margin-bottom:24px;font-weight:700;font-size:13px;letter-spacing:1px}
.lv-subtitle{color:rgba(255,255,255,.85);font-size:13px;text-align:center;margin-bottom:24px;line-height:1.6}
.lv-form{width:100%}
.lv-field{margin-bottom:16px}
.lv-label{display:block;color:rgba(255,255,255,.7);font-size:13px;margin-bottom:6px}
.lv-input{width:100%;padding:11px 14px;border-radius:10px;border:1.5px solid rgba(255,255,255,.15);background:rgba(255,255,255,.08);color:#fff;font-size:14px;outline:none;box-sizing:border-box;transition:border-color .2s}
.lv-input::placeholder{color:rgba(255,255,255,.35)}
.lv-input:focus{border-color:rgba(255,255,255,.5)}
.lv-btn{width:100%;padding:13px;border-radius:40px;border:none;background:#fff;color:#001830;font-weight:700;font-size:15px;cursor:pointer;transition:opacity .2s;margin-top:8px}
.lv-btn:disabled{opacity:.5;cursor:not-allowed}
.lv-err{background:rgba(248,113,113,.15);border:1px solid rgba(248,113,113,.4);color:#fca5a5;padding:10px 14px;border-radius:8px;font-size:13px;margin-top:12px}
.lv-link{color:rgba(255,255,255,.55);font-size:12px;text-align:center;margin-top:14px;cursor:pointer;text-decoration:underline}
.lv-captcha-box{display:flex;align-items:center;gap:10px}
.lv-captcha-q{flex:1;padding:11px 14px;border-radius:10px;background:rgba(255,255,255,.06);border:1.5px solid rgba(255,255,255,.1);color:rgba(255,255,255,.9);font-size:15px;font-weight:600}
.lv-captcha-a{width:90px!important;flex-shrink:0}
.lv-captcha-refresh{background:none;border:none;color:rgba(255,255,255,.5);cursor:pointer;font-size:22px;padding:6px;line-height:1}
.lv-socials{margin-top:28px;display:flex;justify-content:center;align-items:center;gap:16px}
.social_logo{height:24px;width:auto;display:block}
@media(max-width:820px){.lv-hero{display:none}.lv-panel{width:100%;border-left:none;padding:32px 24px}}
`

class LoginAdminView extends React.Component {
  constructor(props) {
    super(props)
    const cap = genCaptcha()
    this.state = {
      email: '', password: '',
      captchaQ: cap.q, captchaAnswer: cap.answer, captchaInput: '',
      error: '', loading: false,
      rateLimited: false, rateLimitMessage: ''
    }
  }

  componentDidMount() {
    if (!document.getElementById('lv-styles')) {
      const s = document.createElement('style'); s.id = 'lv-styles'; s.textContent = STYLES; document.head.appendChild(s)
    }
    if (rateLimiter.isRateLimited()) {
      this.setState({ rateLimited: true, rateLimitMessage: `Demasiados intentos fallidos. Espera ${rateLimiter.getFormattedTimeUntilReset()}.` })
    }
  }

  refreshCaptcha() {
    const cap = genCaptcha()
    this.setState({ captchaQ: cap.q, captchaAnswer: cap.answer, captchaInput: '' })
  }

  async handleSubmit(e) {
    e.preventDefault()
    const { email, password, captchaInput, captchaAnswer } = this.state
    if (!email || !password) { this.setState({ error: 'Email y contraseña son obligatorios.' }); return }
    if (!captchaInput) { this.setState({ error: 'Debes responder la verificación de seguridad.' }); return }
    if (parseInt(captchaInput, 10) !== captchaAnswer) {
      this.setState({ error: 'Respuesta de verificación incorrecta.' })
      this.refreshCaptcha()
      return
    }
    if (rateLimiter.isRateLimited()) { this.setState({ rateLimited: true, rateLimitMessage: `Demasiados intentos fallidos. Espera ${rateLimiter.getFormattedTimeUntilReset()}.` }); return }
    this.setState({ loading: true, error: '' })
    const result = await this.props.authLogin({ email, password }, true)
    if (result && result.error) {
      rateLimiter.recordAttempt()
      if (rateLimiter.isRateLimited()) this.setState({ rateLimited: true, rateLimitMessage: `Demasiados intentos fallidos. Espera ${rateLimiter.getFormattedTimeUntilReset()}.` })
      this.setState({ error: result.error.message || 'Error al iniciar sesión.', loading: false })
      this.refreshCaptcha()
    } else {
      rateLimiter.reset()
      this.props.push('/')
    }
  }

  render() {
    const { email, password, captchaQ, captchaInput, error, loading, rateLimited, rateLimitMessage } = this.state
    return (
      <div className="lv-wrap">
        <div className="lv-hero">
          <img src="/images/lockers_render.png" alt="VACWAYlockers" />
        </div>
        <div className="lv-panel">
          <LoginLangSelector />
          <img className="lv-logo" src="/images/logo.svg" alt="VACWAYlockers" />
          <div className="lv-title">SMART LOCKERS</div>
          <div className="lv-admin-badge">
            <img src="/images/shield.png" alt="Admin" style={{ height: 20 }} />
            MODO ADMINISTRADOR
          </div>
          {rateLimited ? (
            <div className="lv-err">⚠️ Acceso temporalmente bloqueado. {rateLimitMessage}</div>
          ) : (
            <form className="lv-form" onSubmit={e => this.handleSubmit(e)}>
              <div className="lv-field">
                <label className="lv-label">Email</label>
                <input className="lv-input" type="email" value={email} autoComplete="username"
                  placeholder="tu@email.com" onChange={e => this.setState({ email: e.target.value })} />
              </div>
              <div className="lv-field">
                <label className="lv-label">Contraseña</label>
                <input className="lv-input" type="password" value={password} autoComplete="current-password"
                  placeholder="••••••••" onChange={e => this.setState({ password: e.target.value })} />
              </div>
              <div className="lv-field">
                <label className="lv-label">Verificación de seguridad</label>
                <div className="lv-captcha-box">
                  <div className="lv-captcha-q">{captchaQ}</div>
                  <input className="lv-input lv-captcha-a" type="number" value={captchaInput}
                    placeholder="?" onChange={e => this.setState({ captchaInput: e.target.value })} />
                  <button type="button" className="lv-captcha-refresh" title="Nueva pregunta"
                    onClick={() => this.refreshCaptcha()}>↻</button>
                </div>
              </div>
              <div className="lv-link" onClick={() => history.push('/passwordrecovery')}>¿Has olvidado tu contraseña?</div>
              {error && <div className="lv-err">{error}</div>}
              <button className="lv-btn" type="submit" disabled={loading}>
                {loading ? 'Entrando...' : 'Entrar'}
              </button>
            </form>
          )}
          <div className="lv-socials">
            <a href="https://vacway.com/es?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
              <img className="social_logo" src="/images/social/www.png" alt="Web" />
            </a>
            <a href="https://es.linkedin.com/company/vacway?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
              <img className="social_logo" src="/images/social/linkedin.png" alt="LinkedIn" />
            </a>
            <a href="https://www.instagram.com/vacway/?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
              <img className="social_logo" src="/images/social/instagram.png" alt="Instagram" />
            </a>
            <a href="https://www.tiktok.com/@vacway?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
              <img className="social_logo" src="/images/social/tiktok.png" alt="TikTok" />
            </a>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  authLogin: bindActionCreators(authLogin, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(() => ({}), mapDispatchToProps)(LoginAdminView)
